import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboUnidadeComponent} from './combo-unidade.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboUnidadeComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboUnidadeComponent]
})
export class ComboUnidadeModule {
}
